import * as React from 'react';
import { Input, Label, Segment, Form, Button, Modal } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth from '../../../api';

class State {
    file: any;
    showModal: boolean;
    modalHeader: string;
    modalContent: string;
    buildVersion: string;
    installDate: string;
}

interface Props {

}

export default class SoftwareUpdatePanel extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            file: null,
            showModal: false,
            modalHeader: '',
            modalContent: ''
        });
        // tslint:disable-next-line:variable-name
        let __this = this;
        axios.get('http://default/api/sys/status')
            .then(function (response: AxiosResponse) {

                if (response.data !== undefined) {
                    __this.setState({
                        buildVersion: response.data.ver,
                        installDate: response.data.installDate
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected system status, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('system status error, got: ', error);
            });
    }

    onUploadInstallerFile(e: any) {
        e.preventDefault();
        // tslint:disable-next-line:variable-name
        let __this = this;
        const uploadUrl = 'http://default/api/sys/firmware/upload';
        const restartUrl = 'http://default/api/sys/restart';

        let formData = new FormData();
        formData.append('installer_file', this.state.file);

        axios.post(uploadUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-meta-caption': 'Uploading software image...' // triggers loader during the request
            }
        }) .then( response => {
            if (response.data !== undefined && response.data.code === 'SUCCESS' ) {

                axios.post(restartUrl, {
                    'firmwareUpgrade': true
                })
                    .then( function(resp: AxiosResponse) {
                        if (resp.data !== undefined && resp.data.code === 'SUCCESS' ) {

                            const { oauth, key } = OAuth.getContextFromResponseObject(resp);
                            if (oauth) {
                                oauth.waitforServer({
                                    message: 'Upgrading system...please wait.'
                                },                  key)
                                // .then()   // could use then() to capture a success condition but shouldnt happen since we expect a reboot
                                // tslint:disable-next-line:no-console
                                    .catch( er => console.log(er) );  // this is always called if the server reboot succeeds (but we get redirected to login anyway)
                            }
                        } else throw resp;
                    })
                    .catch(function (err: AxiosRequestConfig) {
                        // tslint:disable-next-line:no-console
                        console.log('firmwareUpgrade restart error: ', err);
                    });
            } else throw response;
        })
            .catch(error => {
                if (!error || !error.response || !error.response.data)
                    // tslint:disable-next-line:no-console
                    console.log('upload error: ', error);
                __this.setState({
                    showModal: true,
                    modalHeader: 'Error!',
                    modalContent:  (error && error.response && error.response.data) ? error.response.data.det : 'operation aborted, unspecified error performing upgrade',
                });
            });
    }

    handleModalClose() {
        this.setState({
            showModal: false
        });
    }

    render() {
        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <React.Fragment>
                <div className="assetAliasFilters">
                    <Label className="system-config-pageHeader">
                        Software Update
                    </Label>
                </div>
                <Segment.Group className="system-config-segment">
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="right-align-label-150">
                                    Build Version:
                                </Label>
                                <Label className="system-config-label">
                                    {this.state.buildVersion}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-150">
                                    Install Date:
                                </Label>
                                <Label className="system-config-label">
                                    {this.state.installDate}
                                </Label>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
                <Segment.Group className="system-config-segment">
                    <form onSubmit={(e: any) => this.onUploadInstallerFile(e)} >
                        <Segment className="gray-background">
                            <Input
                                className="system-config-segment-fileField"
                                type="file"
                                label="New Software(.tar/.gz) file:"
                                onChange={(e: any) => this.setState({file: e.target.files[0]})}
                            />
                            <Button type="submit" className="system-config-segment-btn">
                                Update
                            </Button>

                            <Form.Group grouped>
                                <Label className="system-config-label software-update-labelWarning">
                                    A software update will cause either a restart of the application or a reboot of the probe.
                                    The installer will automatically determine the action required.   A reboot of the probe will take
                                    significantly longer than a restart of the application.   A reboot of the probe may take minutes
                                    while a restart of the application will only take a few seconds.
                                    Note that when reverting to an older software version, the current system configuration will not
                                    automatically be restored after the installation.   If the older version had been installed previously,
                                    then the application will revert to the older version system configuration. If the older version had not
                                    been installed previously, then the application will revert to its default configuration.
                                    If the user wishes to restore the current configuration, then the existing system configuration should be uploaded
                                    and saved prior to reverting.   The saved configuration can be downloaded after the software installation.
                                </Label>
                            </Form.Group>
                        </Segment>
                    </form>
                </Segment.Group>
                <Modal
                    open={this.state.showModal}
                    onClose={this.handleModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>{this.state.modalHeader}</Modal.Header>
                    <Modal.Content>
                        {this.state.modalContent}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn" onClick={() => this.handleModalClose()}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/system/softwareUpdate.tsx